import { CollectionsState } from 'types'

export const initialState: CollectionsState = {}

type FetchCollectionsDoneAction = {
  type: 'FETCH_COLLECTIONS_DONE'
  data: {
    queryString: string
    response: {
      result: Array<number>
      count: number
    }
    page: number
  }
}

type CollectionsReducerActionTypes = FetchCollectionsDoneAction

export const reducer = (state: CollectionsState = initialState, action: CollectionsReducerActionTypes): CollectionsState => {
  switch (action.type) {
    case 'FETCH_COLLECTIONS_DONE': {
      const {
        data: {
          queryString,
          response: { result, count },
          page,
        },
      } = action
      const oldCollectionIds = state[queryString]?.ids
      const mergedCollectionIds = page === 1 ? result : [...(oldCollectionIds || []), ...result]
      return {
        ...state,
        [queryString]: {
          count,
          lastPageLoaded: page,
          ids: mergedCollectionIds,
          result: [],
        },
      }
    }
    default:
      return state
  }
}

export default reducer
